module.exports = __webpack_public_path__ + "img/partner-9.2c983fef.png";